// ========== GET METHODS ==========
export const exportExcel = () => 'loan-statistics/export-excel/'
export const exportReportMC = () => 'statistics/annual/'
export const getLoanRaking = () => 'statistics/loans/ranking/'
export const exportSummaryMonthReport = () => 'loans/loans_historical/export_monthly_statistics/'

// ========== POST METHODS ==========
export const exportLoansCSV = () => 'reports/loan-history/export-loans-csv/'
